export default "__VITE_ASSET__CHvotOG5__"